<script setup lang="ts">
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import { useInternalScenarioChatFormStore } from '../../form/form'
import { computed, reactive } from 'vue'

const props = defineProps<{
  selectedMessageClientOnlyId: string
}>()

const formStore = reactive(useInternalScenarioChatFormStore())

const fallbackUrl = computed(() => {
  const message =
    formStore.formValues.messages[props.selectedMessageClientOnlyId]
  if (message.selections.type !== 'BookingRequestSelections') {
    throw new Error('message.selections.type is not BookingRequestSelections')
  }

  return message.selections.fallbackUrl
})

const handleUpdateFallbackUrl = (v: string) => {
  formStore.updateMessage(props.selectedMessageClientOnlyId, draft => {
    if (draft.selections.type !== 'BookingRequestSelections') {
      throw new Error('draft.selections.type is not BookingRequestSelections')
    }

    draft.selections.fallbackUrl = v
  })
}
</script>

<template>
  <div :class="$style.container">
    <label :class="$style.label">外部カレンダー URL（任意）</label>
    <DolphinTextInput
      :class="$style.input"
      :modelValue="fallbackUrl"
      @update:modelValue="$event => handleUpdateFallbackUrl($event as string)"
    />
    <p :class="$style.fallbackNote">
      ここに URL
      を入力すると、「別の日程を選ぶ」がオカネコカレンダーではなく、入力された
      URL が開きます
    </p>
  </div>
</template>

<style lang="scss" module>
.container {
  height: 36px;
}

.label {
  font-size: 15px;
  font-weight: 500;
}

.input {
  font-size: 12px;
  margin-top: 8px;
  width: 100%;
}

.fallbackNote {
  font-size: 12px;
  color: $color-text-and-object-medium-emphasis;
}
</style>
